module.exports = __webpack_public_path__ + "static/img/pingguo.fa020cb6.png";